import { getConversationHydrationCoordinator } from './conversationHydrationCoordinator';
import type { ChatStoreAction } from './types';

/**
 * Utils function to remove conversation from store
 */
export const removeConversationFromStore =
	({ conversationId }: { conversationId: string }): ChatStoreAction =>
	({ getState, setState }, { assistanceService, getConversationHydrationScopeKey }) => {
		const scopeKey = getConversationHydrationScopeKey?.();
		if (scopeKey != null) {
			getConversationHydrationCoordinator(assistanceService, scopeKey).markRemoved(conversationId);
		}
		const { [conversationId]: _, ...otherConversations } = getState().conversations;
		setState({
			conversations: otherConversations,
		});
	};
